import { CustomerRoleOnly } from '@/api/apis/customer';

export const excludeRole = (allRoles: CustomerRoleOnly[], ...rolesToExclude: CustomerRoleOnly[]) =>
  allRoles.filter((r: CustomerRoleOnly) => !rolesToExclude.includes(r));
